import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import IconWrapper from './IconWrapper';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { theme } from '../../Template1/Template';

const WhatsappButton = ({ whatsappNumber }) => {
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  if(whatsappNumber)
  return(
    <Box position="fixed" zIndex={200} right={matches ? 20 : 2} bottom={65}>
      <IconWrapper
        onClick={() => window.open(`https://wa.me/${whatsappNumber}`, '_blank')}
        color="white"
        bgcolor="#25D366"
        p={1}
        border=""
        iconButton
      >
        <WhatsAppIcon style={{ fontSize: '1.6rem' }} />
      </IconWrapper>
    </Box>
  );

  return null;
};

export default WhatsappButton;
